// @section 1 MSAL Singleton
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

let _resolveOnce: (() => void) | null;
export const authReady = new Promise<void>((r) => { _resolveOnce = r; });
export function resolveAuthReady() { _resolveOnce?.(); _resolveOnce = null; }
